import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect, useCallback} from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import HomepageHeaderCarouselBlockData from 'Models/Content/HomepageHeaderCarouselBlockData';
import HomepageHeaderCarouselItemData from 'Models/Content/HomepageHeaderCarouselItemData';
import HomepageTabBlockData from 'Models/Content/HomepageTabBlockData';
import SwiperCore, {Autoplay, EffectFade} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import BackgroundVideo from '../../Page/TVLobbyPage/BackgroundVideo';
import classNames from 'classnames';
import 'swiper/swiper.scss';
import {useInView} from 'react-intersection-observer';
import {isMobile} from 'react-device-detect';
import {getImageProps, ImageProps, getVideoLink, getBackgroundImageProps, BackgroundImageProps} from 'app/utilities/ImageProps';
import {inActiveButton, activeButton} from './images/base64Images';
import MarketingTextBlockData from 'Models/Content/MarketingTextBlockData';
import TagName from 'app/Components/Shared/TagName';
import {setSelectedPackage} from '../SalePackagesBlock/salePackagesBlockSlice';
import {packageResponse} from '../../../utilities/SalePackagesHelper';
import {connect} from 'react-redux';

SwiperCore.use([Autoplay, EffectFade]);

const TRANSITION_TIME = 300;

type HomepageHeaderCarouselItem = {
  imageDesktop: ImageProps;
  imageMobile: ImageProps;
  videoDesktopUrl: string;
  videoMobileUrl: string;
  text: string;
  subtitle: string;
  buttonLink: string;
  buttonText: string;
  isWhiteText: boolean;
  titleHeadLineTag: number;
  subtitleHeadLineTag: number;
  selectedPackage: any;
};

type HomepageTabItem = {
  title: string;
  icon: BackgroundImageProps;
};

const HomepageHeadeCarouselBlock = (props: ComponentProps<HomepageHeaderCarouselBlockData>) => {
  const [animating, setAnimating] = useState(false);
  const [swiperInstence, setSwiperInstence] = useState<SwiperCore>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [fullScreen, setFullScreen] = useState(true);
  const [fullImage, setFullImage] = useState(true); // keep image at full size during transition to avoid mobile jumping in animations
  const [top, setTop] = useState<Number | null>(null);
  const {ref: topRef, inView: topInView, entry: topEntry} = useInView();
  const {ref: bottomRef, inView: bottomInView, entry: bottomEntry} = useInView();

  const items: HomepageHeaderCarouselItem[] = props.data.lItems.expandedValue.map((item: HomepageHeaderCarouselItemData) => {
    const text =
      !isMobile && item.desktopTitle?.expandedValue
        ? (item.desktopTitle.expandedValue[0] as MarketingTextBlockData).text.value
        : item.title.value;
    const subtitle = !isMobile && item.desktopSubtitle?.value ? item.desktopSubtitle?.value : item.subtitle?.value;

    const titleHeadLineTag = item.titleHeadlineTag?.value ? item.titleHeadlineTag?.value : 2;
    const subtitleHeadLineTag = item.subtitleHeadlineTag?.value ? item.subtitleHeadlineTag.value : 7;
    const imageDesktop = getImageProps(item.image, props.context);
    const imageMobile = getImageProps(item.mobileImage, props.context);
    const videoDesktopUrl = getVideoLink(item.video, props.context);
    const videoMobileUrl = getVideoLink(item.mobileVideo, props.context);
    const buttonLink = item.link?.value;
    const buttonText = item.linkTitle?.value;
    const isWhiteText = item.whiteColoredTitle?.value;
    const selectedPackage = item.package?.expandedValue;
    return {
      imageDesktop,
      imageMobile,
      videoDesktopUrl,
      videoMobileUrl,
      text,
      subtitle,
      titleHeadLineTag,
      subtitleHeadLineTag,
      buttonLink,
      buttonText,
      isWhiteText,
      selectedPackage,
    };
  });

  const tabs: HomepageTabItem[] = props.data.tabs?.expandedValue?.map((tab: HomepageTabBlockData) => {
    const title = tab.title?.value;
    const icon = getBackgroundImageProps(tab.backGroundImage, props.context);
    return {title, icon};
  });

  useEffect(() => {
    setAnimating(true);
    const timeout = setTimeout(() => setAnimating(false), TRANSITION_TIME);
    return () => {
      clearTimeout(timeout);
    };
  }, [fullScreen]);

  useEffect(() => {
    if (animating || !topEntry || !bottomEntry) return;
    if (topInView && !bottomInView) {
      setFullScreen(true);
    } else {
      setFullScreen(false);
    }
  }, [topInView, bottomInView, topEntry, bottomEntry, animating]);

  useEffect(() => {
    let timeout;

    if (fullScreen) {
      swiperInstence?.autoplay.stop();
      setFullImage(true);
      timeout = setTimeout(() => swiperInstence?.update(), TRANSITION_TIME);
    } else {
      swiperInstence?.autoplay.start();
      timeout = setTimeout(() => setFullImage(false), TRANSITION_TIME);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [fullScreen, swiperInstence]);

  const anchorCallback = useCallback((node: HTMLDivElement) => {
    bottomRef(node);
    setTimeout(() => {
      if (node) setTop(node.offsetTop - window.innerHeight);
    });
  }, []);

  const getButtonClassByName = (index) => {
    let className = 'HomepageHeadeCarousel__link';
    if (
      props.data.tabs?.expandedValue != null &&
      props.data.tabs?.expandedValue.length > 0 &&
      props.data.tabs?.expandedValue[index] != null
    ) {
      var blockButton = (props.data.tabs.expandedValue[index] as any).blockButton.expandedValue;
      if (blockButton != null) {
        var designType = blockButton[0].buttonDesignMode.value;
        switch (designType) {
          case 0:
            className = className + ' HomepageHeadeCarousel__link_purple';
            break;
          case 1:
            className = className + ' HomepageHeadeCarousel__link_black';
            break;
          case 2:
            className = className + ' HomepageHeadeCarousel__link_white';
            break;
        }
      }
      return className;
    }
  };

  const buttonCarousel = (props, arrayItem) => {
    const urlPage = arrayItem.buttonLink;
    if(arrayItem.selectedPackage != null){
      const selectedPackage = arrayItem.selectedPackage[0];
      const packageResponseObj = packageResponse(selectedPackage);
      props.setSelectedPackage(packageResponseObj);
    }
    if (urlPage) {
      props.context.navigateTo(urlPage);
    }
  };

  const setButtonTextByIndexId = (index) => {
    if (
      props.data.tabs?.expandedValue != null &&
      props.data.tabs?.expandedValue.length > 0 &&
      props.data.tabs?.expandedValue[index] != null
    ) {
      var blockButton = (props.data.tabs.expandedValue[index] as any).blockButton.expandedValue;
      if (blockButton != null) {
        var designText = blockButton[0].text.value;
        return designText;
      }
    }

    var buttonTextValue = (props.data.lItems.expandedValue[index] as any).linkTitle.value;
    return buttonTextValue;
  };
  return (
    <>
      <div ref={topRef} className='HomepageHeadeCarousel__anchor'></div>
      <div
        className={`HomepageHeadeCarousel ${fullScreen ? 'fullScreen' : ''}`}
        style={{transitionDuration: `${TRANSITION_TIME}ms`, marginTop: !fullScreen ? `${top ? (top as number) * 3 : null}px` : null}}>
        <Swiper
          className={`HomepageHeadeCarousel__swiper ${fullScreen ? 'fullScreen' : ''}`}
          onSwiper={(swiper) => {
            setSwiperInstence(swiper);
          }}
          autoplay={{delay: 4000}}
          effect='fade'
          onSlideChange={(swiper) => {
            setActiveIndex(swiper?.activeIndex);
          }}>
          {items?.map((item, i) => (
            <SwiperSlide key={i} className={classNames(`HomepageHeadeCarousel__slide`, {fullImage})}>
              <BackgroundVideo
                videoUrl={isMobile ? item.videoMobileUrl : item.videoDesktopUrl}
                fallbackImageProps={isMobile ? item.imageMobile : item.imageDesktop}
              />
              <div className={classNames('HomepageHeadeCarousel__contentContainer', {whiteText: item.isWhiteText})}>
                {item.text.length > 0 && (
                  <TagName tagName={item.titleHeadLineTag} isTitle className='HomepageHeadeCarousel__title'>
                    {item.text}
                  </TagName>
                )}
                {item.subtitle.length > 0 && (
                  <TagName tagName={item.subtitleHeadLineTag} className='HomepageHeadeCarousel__subtitle'>
                    {item.subtitle}
                  </TagName>
                )}
                {item.buttonLink?.length > 0 && (
                  <button onClick={() => buttonCarousel(props, item)} className={getButtonClassByName(i)}>
                    {setButtonTextByIndexId(i)}
                  </button>
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <ul className={`HomepageHeadeCarousel__Slides_Buttons ${fullScreen ? 'fullScreen' : ''}`}>
          {tabs?.map((tab, i) => (
            <li role='button' tabIndex={0} key={i} onClick={() => swiperInstence?.slideTo(i)} className={activeIndex === i ? 'active' : ''}>
              <Image className='background-icon' src={activeIndex !== i ? inActiveButton : activeButton} />
              <div className='icon' {...tab.icon}></div>
              {tab.title && <span>{tab.title}</span>}
            </li>
          ))}
        </ul>
      </div>
      <div
        ref={anchorCallback}
        className='HomepageHeadeCarousel__anchor'
        style={{position: 'absolute', bottom: top ? `-${top ? (top as number) * 4 : null}px` : '-80px'}}></div>
    </>
  );
};

const mapStateToProps = (state?: any) => {
  return {
    selectedPackage: state.SalePackagesBlock.selectedPackage,
  };
};

const mapDispatchToProps = {setSelectedPackage};

export default connect(mapStateToProps, mapDispatchToProps)(HomepageHeadeCarouselBlock);
